export const state = {
  verified: false,
}

// export const getters = {}

// export const actions = {}

export const mutations = {
  verify (state) {
    state.verified = true
  },
}
